/* eslint @typescript-eslint/no-var-requires: "off" */
import * as api from "../../constant/NewAPI";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Utils from "../../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";


// const api = require("../../constant/API");

const SportCoachList = () => {

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState("");
    const [coachList, setCoachList] = useState([]);
    const [institutionsList, setInstitutionsList] = useState([]);
    const [sportsList, setSportsList] = useState([]);
    const [sportCoachList, setSportCoachList] = useState([]);
    const [instId, setInstId] = useState("");
    const [cochId, setCochId] = useState("");
    const [sprtId, setSprtId] = useState("");
    const [rowId, setRowId] = useState("");
    const [error, setError] = useState("");
    const [updateStatus, setUpdateStatus] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        getCoachList();
        instList();
        sportList();
    }, [])

    function getCoachList() {
        const getCochLst = api.adminSportCoachList + "/" + roleId;
        fetch(getCochLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.error == true) {
                    if (lstResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    const sortedData = lstResult.data.sort((a, b) => {
                        if (!a.InstitutionName) return 1; // Place undefined or null values at the end
                        if (!b.InstitutionName) return -1;
                        return a.InstitutionName.localeCompare(b.InstitutionName);
                    });

                    // console.log("Here sorted",sortedData);
                    setCoachList(sortedData);
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the institution manager list", error)
            })
    }

    function instList() {
        const getInstitutes = api.InstitutionList //+ "?userId=" + userId + "&roleId=" + roleId;
        fetch(getInstitutes, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instResponse) => instResponse.json())
            .then((instResult) => {
                if (instResult.error == true) {
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (instResult.data && instResult.data != null) {
                        const filteredInstitutions = instResult.data.filter(inst => inst.institutionStatus === "1");
                        setInstitutionsList(filteredInstitutions);
                    } else {
                        setInstitutionsList([]);
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the institute list", error);
            })
    }

    function sportList() {
        const getSportsList = api.SportList;
        fetch(getSportsList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.error == true) {
                    if (sprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    setSportsList(sprtResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the sports list", error);
            })
    }

    function getSportCoachList(sprt) {
        const getSprtCoachList = api.AssignCoachList + "/" + sprt;
        fetch(getSprtCoachList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.error == true) {
                    if (sprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    // Ensure the state is always an array
                    const coachList = sprtResult.data
                        ? Array.isArray(sprtResult.data)
                            ? sprtResult.data
                            : [sprtResult.data] // Convert single object to array
                        : [];
                    setSportCoachList(coachList)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch sport coach list", error)
            })
    }

    function chekSportExist(coch) {
        const checkSportCoach = api.CheckSportCoach + '/' + coch + '/' + sprtId + '/' + instId // "?institutionId=" + instId + "&sportId=" + sprtId + "&coachId=" + coch;
        fetch(checkSportCoach, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((checkResponse) => checkResponse.json())
            .then((checkResult) => {
                if (checkResult.error == true) {
                    if (checkResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (checkResult.data == true) {
                        setError("This Coach Already Assigned for this Sport.")
                    }
                    else {
                        setError("");
                    }
                }
            })
    }

    function saveSportCoach() {
        if (isEdit) {
            updateSportCoach();
        }
        else {
            const formData = new FormData();
            formData.append("icsInstitution", instId);
            formData.append("icsSport", sprtId);
            formData.append("icsCoach", cochId);

            if (error == "") {
                const addSportCoach = api.AddSportCoach;
                fetch(addSportCoach, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((addResponse) => addResponse.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("Failed to assign the coach for the sport", error);
                    })
            }
        }
        setOpenModal(false);
    }

    function newSportCoach() {
        setRowId('');
        setInstId('');
        setSprtId('');
        setCochId('');
        setIsEdit(false)
        setOpenModal(true)
    }

    function editGrade(selectedrow) {
        setRowId(selectedrow.icsId);
        setInstId(selectedrow.icsInstitution);
        setSprtId(selectedrow.icsSport);
        setCochId(selectedrow.icsCoach);
        setUpdateStatus(selectedrow.icsStatus);
        getSportCoachList(selectedrow.icsSport);
        setIsEdit(true)
        setOpenModal(true)
    }

    function updateSportCoach() {
        const formData = new FormData();
        formData.append("icsId", rowId);
        formData.append("icsInstitution", instId);
        formData.append("icsSport", sprtId);
        formData.append("icsCoach", cochId);
        formData.append("icsStatus", updateStatus);
        const updateSportCoach = api.SportCoachEdit;
        fetch(updateSportCoach, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    const filteredData = coachList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value?.toString().toLowerCase() ?? ""
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editGrade(rowData)}>
                <i className="feather-edit" />
                Edit
            </Link>
        );
    };

    const instituteRender = (rowData) => {
        return <span>{rowData.InstitutionName}</span>
    }

    const sprtRender = (rowData) => {
        return <span>{rowData.SportName}</span>
    }

    const coachRender = (rowData) => {
        return <span>{rowData.CoachName}</span>
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {(roleId == '1' || roleId == '3' || roleId == '5') ? (
                                            <>
                                                <div className="row col-md-12">
                                                    <div className="col-md-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={() => { newSportCoach(); }}>
                                                            <i className="fas fa-user-check" />&nbsp;
                                                            Assign Sport-Coach
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="InstitutionName"
                                                    body={instituteRender}
                                                    header="Institute"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="SportName"
                                                    header="Sports"
                                                    body={sprtRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="CoachName"
                                                    header="Coach"
                                                    body={coachRender}
                                                ></Column>
                                                {(roleId == '1' || roleId == '5') ? (
                                                    <Column
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Assign Sport Coach */}
            <Modal
                show={openModal}
                size="md"
                centered
                onHide={() => setOpenModal(false)}
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case"><i className="fas fa-check" />{isEdit ? "Edit " : "Assign "}Sport - Coach</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <div className="mb-10">
                        <label className="form-label">Institute</label>
                        <Select
                            value={institutionsList.find(ins => ins.institutionId === instId) ? {
                                value: instId,
                                label: institutionsList.find(ins => ins.institutionId === instId).institutionName
                            } : null}
                            onChange={(e) => {
                                if (!isEdit) {
                                    setInstId(e.value);
                                }
                            }}
                            placeholder="Select Institute"
                            isDisabled={isEdit}
                            options={institutionsList.map(ins => ({
                                value: ins.institutionId,
                                label: ins.institutionName
                            }))}>
                        </Select>
                    </div>
                    <div className="mb-10">
                        <label className="form-label">Sport</label>
                        <Select
                            value={sportsList.find(sprt => sprt.sportId === sprtId) ? {
                                value: sprtId,
                                label: sportsList.find(sprt => sprt.sportId === sprtId).sportName
                            } : null}
                            onChange={(e) => {
                                if (!isEdit) {
                                    setSprtId(e.value);
                                    getSportCoachList(e.value);
                                }
                            }}
                            placeholder="Select Sport"
                            isDisabled={isEdit}
                            options={sportsList.map(sprt => ({
                                value: sprt.sportId,
                                label: sprt.sportName
                            }))}>
                        </Select>
                    </div>
                    <div className="mb-10">
                        <label className="form-label">Coach</label>
                        <Select
                            value={sportCoachList.find(coch => coch.internalUserId === cochId) ? {
                                value: cochId,
                                label: sportCoachList.find(coch => coch.internalUserId === cochId).internalUserFirstName + " " +
                                    sportCoachList.find(coch => coch.internalUserId === cochId).internalUserLastName
                            } : null}
                            onChange={(e) => {
                                if (!isEdit) {
                                    setCochId(e.value);
                                    chekSportExist(e.value);
                                }
                            }}
                            placeholder="Select Coach"
                            isDisabled={isEdit}
                            options={sportCoachList.map(coch => ({
                                value: coch.internalUserId,
                                label: coch.internalUserFirstName + " " + coch.internalUserLastName
                            }))}>
                        </Select>
                    </div>
                    {error && <div className="alert alert-danger">{error}</div>}
                    {
                        isEdit ?
                            <>
                                <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                    <label className="form-label">Status</label>
                                </div>
                                <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                    <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                        <input
                                            className="form-check-input text-end"
                                            type="checkbox"
                                            checked={updateStatus === '1'}
                                            id="instistatus"
                                            onChange={(e) => {
                                                setUpdateStatus(e.target.checked ? '1' : '0')
                                            }}
                                        />
                                    </div>
                                </div>
                            </> : null
                    }
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        onClick={() => { saveSportCoach(); setOpenModal(false) }}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                    </Button>
                </ModalFooter>
            </Modal >
            {/* /Assign Sport Coach */}
        </>
    );
}

export default SportCoachList;